export default "__VITE_ASSET__6f1188a4__"